import React, { useCallback } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { Editable, ReactEditor } from 'slate-react';
import isHotkey from 'is-hotkey';
import { toggleMark } from './helpers/utilities';
import Element from './Element';
import Leaf from './Leaf';
import { HOTKEYS } from 'pages/Homepage/helpers/consts';

interface Props {
  editor: ReactEditor;
  isDefaultEditor?: boolean;
}

function EditArea({ editor, isDefaultEditor = false }: Props) {
  const classes = useStyles();
  const renderElement = useCallback(
    props => <Element {...props} editor={editor} isDefaultEditor={isDefaultEditor} />,
    [],
  );
  const renderLeaf = useCallback(props => <Leaf {...props} />, []);

  return (
    <Editable
      renderElement={renderElement}
      renderLeaf={renderLeaf}
      spellCheck
      className={classes.root}
      onKeyDown={event => {
        for (const hotkey in HOTKEYS) {
          if (isHotkey(hotkey, event as any)) {
            event.preventDefault();
            // @ts-ignore
            const mark = HOTKEYS[hotkey];
            toggleMark(editor, mark);
          }
        }
      }}
    />
  );
}

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    borderTop: `0.5px solid ${theme.palette.grey[300]}`,
  },
}));

export default EditArea;
